import React from 'react';

export default class ScanInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      object: this.props.object,
      properties: this.props.properties,
    };
  }

  handleChange = (e) => {
    let object = e.target.value.split("\n").map((input, index, self) => {
      input = input.replace(/\D/g, "");
      return index === self.length - 1 && input.length === 0 ? input : parseInt(input, 10)
    }).filter((value, index, self) => 
      (index === self.length - 1) || (!isNaN(value) && self.indexOf(value) === index)
    );
    this.setState({object});
    this.props.onChange(this.props.objectKey, object);
  }

  componentDidMount = () => {
  }

  componentWillReceiveProps = (props) => {
    if (typeof props.object !== "undefined" && props.object !== null) {
      this.setState({object: props.object});
    }
  }

  render = () => {
    return (
      <textarea
        rows={5}
        value={(this.state.object || []).join("\n")}
        onChange={this.handleChange}
        readOnly={this.props.disabled}
        className="form-control"
        ref={(input) => {this.input = input}}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/input/ScanInput.js